import { gql } from '@apollo/client'

export default gql(`
  query ($searchKey: String $limit: Int $offset: Int $project: String){
    getContentByField(
        searchKey: $searchKey,
        field: COMPETITION,
        offset: $offset,
        limit: $limit
        project: $project
      ) {
        items{
          name
          id: key
        }
    }
  }
  `
)
